//----- Component --------------------------------------------------------/

// Developer :  Daiana Curcio

// Creation Date :15/08/2025

// Version : 1

// Description : Para ver el detalle de los viajes
//========================================================================/}
import React, { useState, useEffect } from "react";
import {
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
} from "@mui/material";
import { UrlApi } from "../../services/apirest";
import moment from "moment";

const ListItemComponent = ({ icon, primary, secondary }) => (
  <ListItem>
    <ListItemAvatar>
      {/* <Avatar sx={{ bgcolor: "#EBF5FB", width: 60, height: 30 }}>{icon}</Avatar> */}
    </ListItemAvatar>
    <ListItemText primary={primary} secondary={secondary} />
  </ListItem>
);

const DetalleViaje = (props) => {
  const { datos } = props;
  //console.log("detalles", datos);

  const [ultimaDerivacion, setUltimaDerivacion] = useState(null);

  const obtenerDetalle = () => {
    fetch(`${UrlApi}/viajes_abastecimiento_historial/${datos.id_viaje}`)
      .then((data) => data.json())
      .then((data) => setUltimaDerivacion(data));
  };
  useEffect(() => {
    obtenerDetalle();
  }, [datos]);

  //  console.log("ULTIMA DERIVACION", ultimaDerivacion);

  return (
    <div>
      <Grid container>
        <List
          sx={{
            width: "1250px",
            bgcolor: "#EBF5FB",
            border: 0.5,
            borderRadius: 1,
            borderColor: "#A9CCE3",
            display: "flex",
          }}
        >
          <ListItemComponent
            primary="Origen del Vehiculo"
            secondary={datos.nombre_origen}
          />
          <ListItemComponent primary="Vehiculo" secondary={datos.patente} />
          <ListItemComponent
            primary="Pto. de Venta"
            secondary={datos.nro_remito_puntodeventa}
          />
          <ListItemComponent
            primary="Nro. Remito"
            secondary={datos.nro_remito_numero}
          />
        </List>
        <List
          sx={{
            width: "1250px",
            bgcolor: "#EBF5FB",
            border: 0.5,
            borderRadius: 1,
            borderColor: "#A9CCE3",
            display: "flex",
          }}
        >
          <ListItemComponent
            primary="Kilometraje Inicial"
            secondary={datos.kilometraje_inicial}
          />
          <ListItemComponent
            primary="Kilometraje Final"
            secondary={datos.kilometraje_final}
          />
          <ListItemComponent
            primary="Fecha Real de Llegada"
            secondary={datos.fecha_llegada}
          />
          <ListItemComponent
            primary="Salida de la petrolera"
            secondary={datos.salida_petrolera}
          />
        </List>

        {datos.derivado === 1 &&
          ultimaDerivacion &&
          ultimaDerivacion.length > 0 && (
            <List
              sx={{
                width: "1250px",
                bgcolor: "#EBF5FB",
                border: 0.5,
                borderRadius: 1,
                borderColor: "#A9CCE3",
                display: "flex",
              }}
            >
              <ListItemComponent
                primary="Derivado por:"
                secondary={ultimaDerivacion[0].usuario_derivacion}
              />
              <ListItemComponent
                primary="Destino anterior:"
                secondary={ultimaDerivacion[0].sucursal_anterior || "-"}
              />
              <ListItemComponent
                primary="Destino Derivado:"
                secondary={ultimaDerivacion[0].sucursal_derivacion}
              />
              <ListItemComponent
                primary="Fecha de Derivación:"
                secondary={
                  ultimaDerivacion[0].fecha_derivacion
                    ? moment(ultimaDerivacion[0].fecha_derivacion).format(
                      "DD/MM/YYYY"
                    )
                    : ""
                }
              />
            </List>
          )}
      </Grid>
    </div>
  );
};

export default DetalleViaje;